import React from 'react'
import SearchCars from "../components/SearchCars";
import { Helmet } from 'react-helmet';

function AllFilters() {

  const pageTitle = "Сите филтри - Пребарување според автомобил";
  const pageDescription = "Погледнете ги сите филтри и пребарувајте според вашиот автомобил. Најдете ги сите филтри што ти се потребни!";
  const pageKeywords = "филтри, пребарување, автомобили, авто филтер, филтри за автомобили, филтер за масло, филтер за уље, филтер за гориво, филтер за воздух, филтер за клима, полен филтер";


  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>

      <div className='flex flex-col justify-start items-center'>
        <h1 className='text-4xl font-bold mb-8'>Сите филтри</h1>
        <SearchCars category={null} allFilters={true} />
      </div>
    </>
  )
}

export default AllFilters
